import React from 'react';
import { FiSearch } from 'react-icons/fi';
import { Input } from '@/components/ui/input';

const SubheaderToolbar = ({
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Cari data...',
  searchAriaLabel = 'Cari data',
  count = 0,
  onReset,
  secondaryActions,
}) => {
  return (
    <div className="flex w-full flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div className="relative w-full max-w-full md:max-w-[360px]">
        <FiSearch className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" aria-hidden />
        <Input
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={searchPlaceholder}
          aria-label={searchAriaLabel}
          className="pl-9"
        />
      </div>
      <div className="flex w-full flex-wrap items-center justify-between gap-2 md:w-auto md:justify-end">
        <span className="text-xs text-slate-500">Menampilkan {count} data</span>
        {onReset ? (
          <button type="button" className="text-xs font-medium text-[#0A84FF] hover:underline" onClick={onReset}>
            Reset
          </button>
        ) : null}
        {secondaryActions || null}
      </div>
    </div>
  );
};

export default SubheaderToolbar;
